<template>
  <li
    class="kt-menu__item"
    :class="{
      'kt-menu__item--open kt-menu__item--rel': is_active,
      'kt-menu__item kt-menu__item--rel': !is_active,
      'btn-li-project': type == 'button',
    }"
    aria-haspopup="true"
  >
    <router-link
      @click="handleGoTo()"
      :to="{ path: link, params }"
      class="kt-menu__link kt-menu__toggle"
      :class="{ 'btn-project': type == 'button' }"
    >
      <span class="kt-menu__link-text"
        >{{ title }}<sup v-if="sup">{{ sup }}</sup></span
      >
    </router-link>
  </li>
</template>

<script>
export default {
  name: "HeaderMenuItem",
  props: ["title", "link", "params", "sup", "type"],
  computed: {
    aaas() {
      return this.$store.state.active_page;
    },
    is_active() {
      return (
        this.title?.toLowerCase() ===
        this.$store.state.active_page?.toLowerCase()
      );
    },
  },
  methods: {
    handleGoTo() {
      this.$emit("click-item");
      this.$store.commit("setActivePage", this.title);
    },
  },
};
</script>

<style>
sup {
  left: 0.2rem;
  font-style: oblique;
}

.kt-menu__item span {
  color: white !important;
}

.kt-menu__item:hover span {
  text-decoration: underline;
}
.kt-menu__item.btn-li-project:hover span {
  text-decoration: none;
  color: black !important;
}
.kt-menu__item.kt-menu__item--open span {
  text-decoration: underline;
}

@media screen and (max-width: 1024px) {
  .kt-menu__item.kt-menu__item--open span {
    color: black !important;
  }
  .kt-menu__item:hover span {
    color: black !important;
  }
}
</style>
